module.exports = __webpack_public_path__ + "static/media/destaque-linhas-dermoglam.ac5dcc07.jpg";